import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = process.env.REACT_APP_API_LICENSED_BASE_URL;

function normalizeLicensedPayload(payload = {}) {
    return {
        licensedId: payload.licensedId ?? payload.LicensedId,
        active: payload.active ?? payload.Active ?? "S",
        domain: payload.domain ?? payload.Domain,
        companyLogo: payload.companyLogo ?? payload.CompanyLogo ?? null,
        platformName: payload.platformName ?? payload.PlatformName,
        homeScreenImage: payload.homeScreenImage ?? payload.HomeScreenImage ?? null,
        colors: payload.colors ?? payload.Colors ?? null,
        phrase: payload.phrase ?? payload.Phrase ?? null,
        companyPhone: payload.companyPhone ?? payload.CompanyPhone ?? null,
        centralPhone: payload.centralPhone ?? payload.CentralPhone ?? null,
        condensedMenu: payload.condensedMenu ?? payload.CondensedMenu ?? null,
        iosLink: payload.iosLink ?? payload.IosLink ?? null,
        androidLink: payload.androidLink ?? payload.AndroidLink ?? null,
        internalLogo: payload.internalLogo ?? payload.InternalLogo ?? null,
        favicon: payload.favicon ?? payload.FaveIcon ?? payload.Favicon ?? null,
        standardLanguage: payload.standardLanguage ?? payload.StandardLanguage ?? "pt-br",
        currentLanguage: payload.currentLanguage ?? payload.CurrentLanguage ?? "pt-br",
    };
}

async function fetchLicenses(licensedId) {
    try {
        let response = await api.get(`${basePath}/licensed/${licensedId}`);

        let treated = errorHandling.handleResponse(
            response,
            "licenseService.fetchLicenses"
        );
        
        if (treated) {
            return Array.isArray(treated) ? treated : [treated];
        }
        return null;
    } catch (error) {
        errorHandling.cathError(error, "licenseService.fetchLicenses");
        return null;
    }
}

async function fetchLicensesByDomain(domain) {
    try {
        const encodedDomain = encodeURIComponent(domain);
        let response = await api.get(`${basePath}/licensed?domain=${encodedDomain}`);

        let treated = errorHandling.handleResponse(
            response,
            "licenseService.fetchLicensesByDomain"
        );
        if (treated) {
            return Array.isArray(treated) ? treated : [treated];
        }
        return null;
    } catch (error) {
        errorHandling.cathError(error, "licenseService.fetchLicensesByDomain");
        return null;
    }
}

async function uploadLicensedImage(imageType, contentFile) {
    try {
        const payload = new FormData();
        payload.append("ImageType", imageType);
        payload.append("ContentFile", contentFile);

        let response = await api.post(`${basePath}/licensed/images`, payload);

        let treated = errorHandling.handleResponse(
            response,
            "licenseService.uploadLicensedImage"
        );

        if (treated) {
            return treated;
        }

        return null;
    } catch (error) {
        errorHandling.cathError(error, "licenseService.uploadLicensedImage");
        return null;
    }
}

async function createLicensed(payload) {
    try {
        const body = normalizeLicensedPayload(payload);

        let response = await api.post(`${basePath}/licensed`, body);

        let treated = errorHandling.handleResponse(
            response,
            "licenseService.createLicensed"
        );

        if (treated) {
            return treated;
        }

        return null;
    } catch (error) {
        errorHandling.cathError(error, "licenseService.createLicensed");
        return null;
    }
}

async function updateLicensed(payload) {
    try {
        const body = normalizeLicensedPayload(payload);

        let response = await api.put(`${basePath}/licensed`, body);

        let treated = errorHandling.handleResponse(
            response,
            "licenseService.updateLicensed"
        );

        if (treated) {
            return treated;
        }

        return null;
    } catch (error) {
        errorHandling.cathError(error, "licenseService.updateLicensed");
        return null;
    }
}

export const licenseService = {
    createLicensed,
    fetchLicenses,
    fetchLicensesByDomain,
    updateLicensed,
    uploadLicensedImage
};